module.exports = __webpack_public_path__ + "static/img/item3.507ced7d.png";